import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'en' | 'es';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  isLoading: boolean;
  showLanguageSelector: boolean;
  handleLanguageSelection: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const [isLoading, setIsLoading] = useState(true);
  const [showLanguageSelector, setShowLanguageSelector] = useState(true);
  useEffect(() => {
    // Always show language selector on page load
    setIsLoading(false);
  }, []);
  const handleLanguageSelection = (lang: Language) => {
    setLanguage(lang);
    setShowLanguageSelector(false);
  };
  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang);
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage: handleSetLanguage,
    isLoading,
    showLanguageSelector,
    handleLanguageSelection
  }} data-id="element-487">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}